import React from "react";
import {
  Accordion as ChakraAccordion,
  type AccordionProps as ChakraAccordionProps,
  type SpaceProps,
} from "@chakra-ui/react";
import { type Theme } from "contexts/color-theme";
import { AccordionItem, type AccordionItemContent } from "./accordion-item";

type BaseAccordionProps = {
  /**
   * The color theme of the accordion.
   *
   * @default "light"
   */
  theme?: Theme;
  /**
   * The accordion items
   */
  items: AccordionItemContent[];
};

export type AccordionProps = BaseAccordionProps &
  Pick<ChakraAccordionProps, "width" | "w" | "maxWidth" | "maxW" | "defaultIndex" | "allowMultiple"> &
  SpaceProps;

export function Accordion({ items, theme = "light", defaultIndex, allowMultiple, ...spaceProps }: AccordionProps) {
  return (
    <ChakraAccordion allowToggle allowMultiple={allowMultiple} defaultIndex={defaultIndex ?? 0} {...spaceProps}>
      {items.map((item) => (
        <AccordionItem key={item.id ?? item.title} theme={theme} {...item} />
      ))}
    </ChakraAccordion>
  );
}
